module.exports = __webpack_public_path__ + "static/media/comment.22e5986f.svg";